import { environment } from '../environments/environment';

export const GRAPHQL_URI = environment.BACKEND_URL;
